import adresseBo from '../Adresse'

var personneBo = {
    civilite: 'm',
    nom: '',
    prenom: '',
    telephone1: '',
    telephone2: '',
    mail: '',
    obs: '',
    adresse : Object.assign({},adresseBo)
};

export default personneBo;


// WEBPACK FOOTER //
// ./src/components/data/client/Personne.js